import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _AirLine, _Airport, _CommercialCampaign, _CountriesVdos, _CustomerAddress } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectSiteID } from "../../../admin/configuracion/SiteID/SelectSiteID";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { StatesCatalog } from "./StatesCatalog/StatesCatalog";
import { Cities } from "./Cities/Cities";


export const Countries = () => {

    const Countries = useDataBean(_CountriesVdos);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [modalcities, setModalcities] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalstates, setModalstates] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        Countries.instance.getCountriesCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const create = () => {
        Countries.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        Countries.instance.deleteCountries(Countries.bean.IDCountries).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        Countries.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCountries', visible: true },
        { title: 'ID Región', property: 'IDRegion', visible: true },
        { title: 'Región', property: 'Region', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'ISO3', property: 'ISO3', visible: true },
        { title: 'Símbolo Moneda', property: 'CurrencySimbol', visible: true },
        { title: 'Moneda', property: 'Currency', visible: true },
        { title: 'Emojiu', property: 'Emojiu', visible: true },
        { title: 'Latitud', property: 'Latitude', visible: true },
        { title: 'Longitud', property: 'Longitude', visible: true },
        { title: 'Nacionalidad', property: 'Nationality', visible: true },
        { title: 'Capital', property: 'Capital', visible: true },
        { title: 'Codigo de Departamento', property: 'InternalStateCode', visible: true },
        { title: 'Código de Estado', property: 'StateCode', visible: true },
        { title: 'Formato de Código', property: 'ViewCodeFormat', visible: true },
        { title: 'Código Telefónico', property: 'PhoneCode', visible: true },
        { title: 'Código Numérico', property: 'NumericCode', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Estados', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalstates({ ...modalstates, "view": true }) } },
            { titulo: 'Ciudades', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalcities({ ...modalcities, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Ciudades y Paises">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={Countries.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>ID Región</label>
                                <input type="text" name="IDRegion" className="form-control" value={Countries.bean.IDRegion} onChange={(e) => { Countries.setBean({ ...Countries.bean, "IDRegion": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Región</label>
                                <input type="text" name="Region" className="form-control" value={Countries.bean.Region} onChange={(e) => { Countries.setBean({ ...Countries.bean, "Region": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={Countries.bean.Name} onChange={(e) => { Countries.setBean({ ...Countries.bean, "Name": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>ISO3</label>
                                <input type="text" name="ISO3" className="form-control" value={Countries.bean.ISO3} onChange={(e) => { Countries.setBean({ ...Countries.bean, "ISO3": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Símbolo Moneda</label>
                                <input type="text" name="CurrencySimbol" className="form-control" value={Countries.bean.CurrencySimbol} onChange={(e) => { Countries.setBean({ ...Countries.bean, "CurrencySimbol": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Moneda</label>
                                <input type="text" name="Currency" className="form-control" value={Countries.bean.Currency} onChange={(e) => { Countries.setBean({ ...Countries.bean, "Currency": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Emojiu</label>
                                <input type="text" name="Emojiu" className="form-control" value={Countries.bean.Emojiu} onChange={(e) => { Countries.setBean({ ...Countries.bean, "Emojiu": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Latitud</label>
                                <input type="text" name="Latitude" className="form-control" value={Countries.bean.Latitude} onChange={(e) => { Countries.setBean({ ...Countries.bean, "Latitude": e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Longitud</label>
                                <input type="text" name="Longitude" className="form-control" value={Countries.bean.Longitude} onChange={(e) => { Countries.setBean({ ...Countries.bean, "Longitude": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nacionalidad</label>
                                <input type="text" name="Nationality" className="form-control" value={Countries.bean.Nationality} onChange={(e) => { Countries.setBean({ ...Countries.bean, "Nationality": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Capital</label>
                                <input type="text" name="Capital" className="form-control" value={Countries.bean.Capital} onChange={(e) => { Countries.setBean({ ...Countries.bean, "Capital": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código Telefónico</label>
                                <input type="text" name="PhoneCode" className="form-control" value={Countries.bean.PhoneCode} onChange={(e) => { Countries.setBean({ ...Countries.bean, "PhoneCode": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código Numérico</label>
                                <input type="text" name="NumericCode" className="form-control" value={Countries.bean.NumericCode} onChange={(e) => { Countries.setBean({ ...Countries.bean, "NumericCode": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Formato de Código</label>
                                <input type="text" name="ViewCodeFormat" className="form-control" value={Countries.bean.ViewCodeFormat} onChange={(e) => { Countries.setBean({ ...Countries.bean, "ViewCodeFormat": e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalstates} updateModal={setModalstates} >
                        <>
                            <StatesCatalog idCountries={Countries.bean.IDCountries} />
                        </>
                    </Modal>
                    <Modal modal={modalcities} updateModal={setModalcities} >
                        <>
                            <Cities idCountries={Countries.bean.IDCountries} />
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {Countries.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}